






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyRoleDto from '@/models/AgencyRoles/AgencyRoleDto';
import UpdateAgencyRoleRequest from '@/models/AgencyRoles/UpdateAgencyRoleRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AgencyRoleEdit'
})
export default class extends GiganautVueDialog {

  public entity: any = new AgencyRoleDto();

  public permissionLevels = [
    { text: 'None', value: 0 },
    { text: 'View', value: 1 },
    { text: 'Manage', value: 2 },
  ];

  public permissionFields = [
    { field: 'permissionWorkers', label: 'Workers' },
    { field: 'permissionCompanies', label: 'Companies' },
    { field: 'permissionLocations', label: 'Locations' },
    { field: 'permissionContacts', label: 'Contacts' },
    { field: 'permissionBookings', label: 'Bookings' },
    { field: 'permissionJobs', label: 'Jobs' },
    { field: 'permissionOpportunities', label: 'Opportunities' },
    { field: 'permissionPayroll', label: 'Payroll' },
    { field: 'permissionSpecOuts', label: 'Spec Outs' },
    { field: 'permissionInvoices', label: 'Invoices' },
    { field: 'permissionTimesheets', label: 'Timesheets' },
    { field: 'permissionCampaigns', label: 'Campaigns' },
    { field: 'permissionMessaging', label: 'Messaging' },
    { field: 'permissionReports', label: 'Reports' },
    { field: 'permissionActivities', label: 'Activities' },
    { field: 'permissionCompliance', label: 'Compliance' },
    { field: 'permissionKpis', label: 'KPIs' },
    // Agency section
    { field: 'permissionSettingsAgencyProfile', label: 'Settings: Agency Profile' },
    { field: 'permissionSettingsBranches', label: 'Settings: Branches' },
    { field: 'permissionSettingsRateCards', label: 'Settings: Rate Cards' },
    { field: 'permissionSettingsUniforms', label: 'Settings: Uniforms' },
    { field: 'permissionSettingsReportingPeriods', label: 'Settings: Reporting Periods' },
    { field: 'permissionSettingsKpis', label: 'Settings: KPIs' },
    // Users & Permissions section
    { field: 'permissionSettingsUsers', label: 'Settings: Users' },
    { field: 'permissionSettingsGroups', label: 'Settings: Groups' },
    { field: 'permissionSettingsRoles', label: 'Settings: Roles' },
    // Communication section
    { field: 'permissionSettingsEmailTemplates', label: 'Settings: Email Templates' },
    { field: 'permissionSettingsConversationTopics', label: 'Settings: Conversation Topics' },
    { field: 'permissionSettingsBusinessHours', label: 'Settings: Business Hours' },
    // Categories section
    { field: 'permissionSettingsNoteCategories', label: 'Settings: Note Categories' },
    { field: 'permissionSettingsActivityCategories', label: 'Settings: Activity Categories' },
    // Work Types section
    { field: 'permissionSettingsIndustries', label: 'Settings: Industries' },
    { field: 'permissionSettingsLocationTypes', label: 'Settings: Location Types' },
    { field: 'permissionSettingsSkills', label: 'Settings: Skills' },
    { field: 'permissionSettingsQualifications', label: 'Settings: Qualifications' },
    { field: 'permissionSettingsPositions', label: 'Settings: Positions' },
    // Integrations section
    { field: 'permissionSettingsIntegrations', label: 'Settings: Integrations' },
    { field: 'permissionSettingsMobileApp', label: 'Settings: Mobile App' },
    // Sales / Pipeline section
    { field: 'permissionSettingsOpportunitySources', label: 'Settings: Opportunity Sources' },
    { field: 'permissionSettingsOpportunityLostReasons', label: 'Settings: Opportunity Lost Reasons' },
  ];

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentAgencyRole));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAgencyRoleRequest();
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.permissionWorkers = this.entity.permissionWorkers;
    request.permissionCompanies = this.entity.permissionCompanies;
    request.permissionLocations = this.entity.permissionLocations;
    request.permissionContacts = this.entity.permissionContacts;
    request.permissionBookings = this.entity.permissionBookings;
    request.permissionJobs = this.entity.permissionJobs;
    request.permissionOpportunities = this.entity.permissionOpportunities;
    request.permissionPayroll = this.entity.permissionPayroll;
    request.permissionSpecOuts = this.entity.permissionSpecOuts;
    request.permissionInvoices = this.entity.permissionInvoices;
    request.permissionTimesheets = this.entity.permissionTimesheets;
    request.permissionCampaigns = this.entity.permissionCampaigns;
    request.permissionMessaging = this.entity.permissionMessaging;
    request.permissionReports = this.entity.permissionReports;
    request.permissionActivities = this.entity.permissionActivities;
    request.permissionCompliance = this.entity.permissionCompliance;
    request.permissionKpis = this.entity.permissionKpis;
    // Agency section
    request.permissionSettingsAgencyProfile = this.entity.permissionSettingsAgencyProfile;
    request.permissionSettingsBranches = this.entity.permissionSettingsBranches;
    request.permissionSettingsRateCards = this.entity.permissionSettingsRateCards;
    request.permissionSettingsUniforms = this.entity.permissionSettingsUniforms;
    request.permissionSettingsReportingPeriods = this.entity.permissionSettingsReportingPeriods;
    request.permissionSettingsKpis = this.entity.permissionSettingsKpis;
    // Users & Permissions section
    request.permissionSettingsUsers = this.entity.permissionSettingsUsers;
    request.permissionSettingsGroups = this.entity.permissionSettingsGroups;
    request.permissionSettingsRoles = this.entity.permissionSettingsRoles;
    // Communication section
    request.permissionSettingsEmailTemplates = this.entity.permissionSettingsEmailTemplates;
    request.permissionSettingsConversationTopics = this.entity.permissionSettingsConversationTopics;
    request.permissionSettingsBusinessHours = this.entity.permissionSettingsBusinessHours;
    // Categories section
    request.permissionSettingsNoteCategories = this.entity.permissionSettingsNoteCategories;
    request.permissionSettingsActivityCategories = this.entity.permissionSettingsActivityCategories;
    // Work Types section
    request.permissionSettingsIndustries = this.entity.permissionSettingsIndustries;
    request.permissionSettingsLocationTypes = this.entity.permissionSettingsLocationTypes;
    request.permissionSettingsSkills = this.entity.permissionSettingsSkills;
    request.permissionSettingsQualifications = this.entity.permissionSettingsQualifications;
    request.permissionSettingsPositions = this.entity.permissionSettingsPositions;
    // Integrations section
    request.permissionSettingsIntegrations = this.entity.permissionSettingsIntegrations;
    request.permissionSettingsMobileApp = this.entity.permissionSettingsMobileApp;
    // Sales / Pipeline section
    request.permissionSettingsOpportunitySources = this.entity.permissionSettingsOpportunitySources;
    request.permissionSettingsOpportunityLostReasons = this.entity.permissionSettingsOpportunityLostReasons;
    // Other
    request.permissionSettingsFaq = this.entity.permissionSettingsFaq;
    await AgencySettingsModule.editAgencyRole(request)
    this.dialog = false;
  }
}
